import sort from '@/auth/sort'
import md5 from 'js-md5'

function sign (params) {
  let secret = 'WDID429FKS92KDK3'
    for (const key in params) {
    if(Array.isArray(params[key])) {
      for(let i = 0; i < params[key].length; i++) {
        let name = key + "[" + i + "]";
        params[name] = params[key][i]
      }
      delete params[key];
    }
  }
  let pstr = sort(params)
  let stringSignTemp = pstr + secret
  console.log(stringSignTemp,'lichunhua')
  return md5(stringSignTemp).toUpperCase()
}

export default sign



// WEBPACK FOOTER //
// ./src/auth/sign.js